<script setup lang="ts">
import ASidebar from '@/components/ASidebar/ASidebar.vue'
</script>

<template>
  <div class="app-shell">
    <ASidebar />

    <div class="app-shell-workspace">
      <router-view />
    </div>
  </div>
</template>

<style scoped>
.app-shell {
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-columns: auto minmax(0, 1fr);
  gap: var(--c-shell-gap);
  overflow: hidden;
  padding: 0;
  background: var(--c-content-bg);
}

.app-shell-workspace {
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.app-shell :deep(.sidebar-root) {
  gap: var(--c-shell-gap);
}

.app-shell :deep(.sidebar-logo-button) {
  border: 0;
  border-radius: 0 0 var(--c-shell-radius) 0;
  background: var(--c-panel-bg);
}

.app-shell :deep(.sidebar-navigation-surface) {
  border: 0;
  border-radius: 0 var(--c-shell-radius) 0 0;
  background: var(--c-panel-bg);
}
</style>
